import * as React from 'react';

import type { ClientApprovalStatus } from 'types';

export type ClientApprovalGalleryContextContent = {
  look: string,
  onAssetApprovalChange: (itemId: number, status: ClientApprovalStatus) => void
};

export default React.createContext<ClientApprovalGalleryContextContent | null>(null);
